import React, { memo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";
import { AppSpecificList } from "../../../constants/headerImage";
import { useSelector } from "react-redux";
import Help from "../help";
import { Container, Logo, Notch } from "./header.styles";

interface IHeader {
  /**
   * background color for the header component.
   * @default "#ffffff"
   */
  color?: string;
  /**
   * App logo size.
   * @default "medium"
   */
  logoSize?: "medium" | "large";
  /**
   * Need help text visibility in header.
   * @default true
   */
  showHelp?: boolean;
  /**
   * Indicator visibility under app logo.
   * @default false
   */
  showIndicator?: boolean;
}

const queryParams = new URLSearchParams(window.location.search);
let app: string = queryParams.get("app") ?? "BRP";
app = app.toUpperCase();
localStorage.setItem("appname", app.toUpperCase());

function Header({
  color = "#ffffff",
  showHelp = true,
  showIndicator = false,
  logoSize = "medium",
}: IHeader) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  return (
    <Container showBorderBottom={!showIndicator} backGroundColor={color}>
      <Logo
        height={logoSize === "medium" ? 60 : 75}
        loading="eager"
        src={AppSpecificList[app]}
        alt="kyc logo"
      />
      {showHelp && (
        <Typography
          variant="h3"
          color="primary"
          fontWeight={600}
          onClick={() => setOpen(true)}
        >
          {t("need_help", { defaultValue: "Need Help?" })}
        </Typography>
      )}
      <Help open={open} close={setOpen} />
      {showIndicator && <Notch />}
    </Container>
  );
}

export default memo(Header);
